export default "__VITE_ASSET__CzpNIVLC__"